exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-articles-newt-post-slug-tsx": () => import("./../../../src/pages/articles/{NewtPost.slug}.tsx" /* webpackChunkName: "component---src-pages-articles-newt-post-slug-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

